import React, { useState } from "react";
import { Send, FileText, CheckCircle, AlertCircle } from "lucide-react";

const TIPURI_ACTIUNI = [
  { value: "Inscriere membru nou", label: "Înscriere membru nou (+200 puncte)", points: 200, manual: false },
  { value: "Plata cotizație", label: "Plata cotizație (+ punctaj conform statut)", points: 0, manual: true },
  { value: "Donatie", label: "Donație (număr personalizat de puncte)", points: 0, manual: true },
  { value: "Finalizare curs", label: "Finalizare curs (20 puncte)", points: 20, manual: false },
  { value: "Participare eveniment", label: "Participare eveniment (50 puncte)", points: 50, manual: false },
  { value: "Alt motiv", label: "Alt motiv (punctaj personalizat)", points: 0, manual: true }
];

const premiumStyles = {
  container: {
    maxWidth: 600,
    margin: "0 auto",
    backgroundColor: "#1e293b",
    padding: "32px",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.05)",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
  },
  title: {
    color: "#f8fafc",
    fontWeight: 700,
    marginBottom: "8px",
    fontSize: "1.5rem",
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  description: {
    color: "#94a3b8",
    marginBottom: "24px",
    fontSize: "0.95rem",
    lineHeight: "1.5"
  },
  label: {
    color: "#cbd5e1",
    fontSize: "0.85rem",
    fontWeight: "600",
    letterSpacing: "0.5px",
    marginBottom: "8px",
    display: "block",
    textTransform: "uppercase"
  },
  input: {
    border: "1px solid rgba(255, 255, 255, 0.1)",
    outline: "none",
    background: "#0f172a",
    color: "#f8fafc",
    borderRadius: "12px",
    padding: "14px 18px",
    fontSize: "1rem",
    marginBottom: "24px",
    width: "100%",
    transition: "all 0.2s ease"
  },
  select: {
    border: "1px solid rgba(255, 255, 255, 0.1)",
    outline: "none",
    background: "#0f172a",
    color: "#f8fafc",
    borderRadius: "12px",
    padding: "14px 18px",
    fontSize: "1rem",
    marginBottom: "24px",
    width: "100%",
  },
  button: {
    background: "#fbbf24",
    color: "#0f172a",
    border: "none",
    borderRadius: "12px",
    fontWeight: 700,
    padding: "14px 24px",
    fontSize: "1rem",
    transition: "all 0.2s ease",
    cursor: "pointer",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginTop: "10px"
  },
  buttonDisabled: {
    background: "#475569",
    color: "#94a3b8",
    cursor: "not-allowed",
  },
  alertError: {
    backgroundColor: "rgba(239, 68, 68, 0.1)",
    color: "#ef4444",
    padding: "12px 16px",
    borderRadius: "10px",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: "500"
  },
  alertSuccess: {
    backgroundColor: "rgba(16, 185, 129, 0.1)",
    color: "#10b981",
    padding: "12px 16px",
    borderRadius: "10px",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: "500"
  },
};

export default function CererePuncte({ memberId }) {
  const [tipActiune, setTipActiune] = useState("");
  const [puncte, setPuncte] = useState("");
  const [motiv, setMotiv] = useState("");
  const [detalii, setDetalii] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  function handleTipActiune(e) {
    const v = e.target.value;
    setTipActiune(v);
    const act = TIPURI_ACTIUNI.find(t => t.value === v);
    if (act) {
      setPuncte(act.points ? act.points.toString() : "");
      setMotiv(act.value);
    } else {
      setPuncte("");
      setMotiv("");
    }
    setDetalii("");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (!tipActiune) return setError("Alege tipul acțiunii.");
    if (!puncte || Number(puncte) <= 0) return setError("Completează punctajul corect.");
    if (!motiv) return setError("Completează motivul.");

    setLoading(true);
    try {
      const payload = {
        id_membru: memberId,
        puncte: Number(puncte),
        motiv,
        detalii,
      };

      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/puncte-requests", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer unwantedtok",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Cererea nu a putut fi trimisă!");
      setSuccessMsg("Cererea a fost trimisă spre aprobare.");
      setTipActiune("");
      setPuncte("");
      setMotiv("");
      setDetalii("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <style>{`
        .premium-input:focus {
          border-color: #fbbf24 !important;
          box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.2) !important;
        }
      `}</style>
      <div style={premiumStyles.container}>
        <h4 style={premiumStyles.title}>
          <FileText color="#fbbf24" size={28} /> Cerere atribuire puncte
        </h4>
        <div style={premiumStyles.description}>
          Completează formularul pentru a solicita atribuirea de puncte de către Biroul Național.
        </div>
        
        {error && <div style={premiumStyles.alertError}><AlertCircle size={20} /> {error}</div>}
        {successMsg && <div style={premiumStyles.alertSuccess}><CheckCircle size={20} /> {successMsg}</div>}
        
        <form onSubmit={handleSubmit} autoComplete="off">
          <label style={premiumStyles.label}>Tip acțiune:</label>
          <select
            style={premiumStyles.select}
            className="premium-input"
            value={tipActiune}
            onChange={handleTipActiune}
            required
          >
            <option value="">-- Alege tip acțiune --</option>
            {TIPURI_ACTIUNI.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>

          <label style={premiumStyles.label}>Puncte solicitate:</label>
          <input
            type="number"
            style={{...premiumStyles.input, opacity: !TIPURI_ACTIUNI.find(a => a.value === tipActiune)?.manual ? 0.6 : 1}}
            className="premium-input"
            value={puncte}
            readOnly={!TIPURI_ACTIUNI.find(a => a.value === tipActiune)?.manual}
            onChange={e => setPuncte(e.target.value)}
            required
          />

          <label style={premiumStyles.label}>Motiv:</label>
          <input
            type="text"
            style={premiumStyles.input}
            className="premium-input"
            value={motiv}
            placeholder="Descrie motivul cererii"
            onChange={e => setMotiv(e.target.value)}
            required
          />

          <label style={premiumStyles.label}>Detalii suplimentare (opțional):</label>
          <textarea
            style={{...premiumStyles.input, resize: "vertical", minHeight: "100px"}}
            className="premium-input"
            value={detalii}
            placeholder="Informații adiționale..."
            onChange={e => setDetalii(e.target.value)}
          />

          <button
            type="submit"
            style={{ ...premiumStyles.button, ...(loading ? premiumStyles.buttonDisabled : {}) }}
            disabled={loading}
          >
            {loading ? "Se trimite..." : <><Send size={18} /> Trimite cererea</>}
          </button>
        </form>
      </div>
    </>
  );
}
